/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const l={point:l=>"point"===l.type?l:"polygon"===l.type||"polyline"===l.type?l.extent?.center??null:null,polygon:l=>"polygon"===l.type?l:null,polyline:l=>"polyline"===l.type?l:null};export{l as default};
